import { FetchVideoViewsResultSort } from '@api'
import { createEvent, createStore, sample } from 'effector'

import { $currentPage } from '@/models/router.ts'

export const setSortOptionSocial =
  createEvent<FetchVideoViewsResultSort>('set sort option')
export const resetSortOptionSocial = createEvent('reset sort option')

export const $socialViewSortOptions = createStore<FetchVideoViewsResultSort>(
  FetchVideoViewsResultSort.VIEWS,
)
  .on(setSortOptionSocial, (_, sortOption) => sortOption)
  .reset(resetSortOptionSocial)

// reset model when we leave pages
sample({
  clock: $currentPage,
  target: resetSortOptionSocial,
})
